import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { payloadChange } from '@/finsight/application/actions/bonds/filters/actions';
import { TBondsFilters } from '@/finsight/domain/vo/Bond/IBondsFilters';

interface ITileContextProviderProps {
  filterPayload?: TBondsFilters,
  enabled?: boolean,
  sectorItem?: {
    sectorId: string,
    subsectorId: string,
  },
  children: React.ReactNode,
}

export const useTile = ({ enabled, filterPayload, sectorItem }: Omit<ITileContextProviderProps, 'children'>) => {
  const dispatch = useDispatch();
  const initBondsTile = async () => {
    dispatch(payloadChange(filterPayload.filter));
  };

  useEffect(() => {
    initBondsTile();
  }, [sectorItem?.sectorId, sectorItem?.subsectorId]);

  return {
    isModuleEnabled: enabled,
  };
};

type TileContextType = ReturnType<typeof useTile>;

export const TileContext = createContext<TileContextType>(null);

export const useTileContext = () => {
  const context = useContext(TileContext);
  if (!context) {
    throw new Error('useTileContext must be used within the TileContext');
  }
  return context;
};

const TileContextProvider = ({
  enabled,
  filterPayload,
  sectorItem,
  children,
}: ITileContextProviderProps) => (
  <TileContext.Provider value={ useTile({ enabled, filterPayload, sectorItem }) }>
    { children }
  </TileContext.Provider>
);

export default TileContextProvider;
